// JGD2011 plane rectangular zones I–XIX: EPSG:6669–6687.
// EPSG:6668 is the geographic CRS, not zone I.
// Projection origins: https://www.gsi.go.jp/sokuchikijun/jpc.html
// Columns: EPSG code, zone label, latitude of origin, central meridian.
const ZONES = [
  [6669, 'I', 33, 129.5],
  [6670, 'II', 33, 131],
  [6671, 'III', 36, 132.166666666667],
  [6672, 'IV', 33, 133.5],
  [6673, 'V', 36, 134.333333333333],
  [6674, 'VI', 36, 136],
  [6675, 'VII', 36, 137.166666666667],
  [6676, 'VIII', 36, 138.5],
  [6677, 'IX', 36, 139.833333333333],
  [6678, 'X', 40, 140.833333333333],
  [6679, 'XI', 44, 140.25],
  [6680, 'XII', 44, 142.25],
  [6681, 'XIII', 44, 144.25],
  [6682, 'XIV', 26, 142],
  [6683, 'XV', 26, 127.5],
  [6684, 'XVI', 26, 124],
  [6685, 'XVII', 26, 131],
  [6686, 'XVIII', 20, 136],
  [6687, 'XIX', 26, 154],
];

export const JGD2011_ZONES = ZONES.map(([code, label, lat, lon], index) => ({
  code,
  label,
  regionKey: `JGD2011_Zone${index + 1}`,
  definition: `+proj=tmerc +lat_0=${lat} +lon_0=${lon} +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs`,
}));

// Zone IX — Tokyo area.
export const DEFAULT_JGD2011_EPSG = 6677;
